import { render, staticRenderFns } from "./NewFooter.vue?vue&type=template&id=25eb69ab&scoped=true"
import script from "./NewFooter.vue?vue&type=script&lang=js"
export * from "./NewFooter.vue?vue&type=script&lang=js"
import style0 from "./NewFooter.vue?vue&type=style&index=0&id=25eb69ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eb69ab",
  null
  
)

export default component.exports